<div class="client-comment">
  <label class="client-comment__label">
    @if (clientName(); as name) {
      {{
        'page.simplified_shift_drawer.client_comment_label_with_client'
          | translate: { clientName: name }
      }}
    } @else {
      {{ 'page.simplified_shift_drawer.client_comment_label' | translate }}
    }
  </label>
  <nz-textarea-count [nzMaxCharacterCount]="maxLength">
    <textarea
      nz-input
      [formControl]="control"
      [class.invalid-comment-input]="control | formControlInvalid"
      [placeholder]="
        'page.simplified_shift_drawer.client_comment_placeholder' | translate
      "
      [rows]="4"
    ></textarea>
  </nz-textarea-count>
  @if (control | formControlInvalid) {
    <span class="client-comment__error">
      @if (control.hasError('required')) {
        {{ 'page.simplified_shift_drawer.client_comment_required' | translate }}
      } @else {
        {{
          'page.simplified_shift_drawer.client_comment_max_length'
            | translate: { maxLength: maxLength }
        }}
      }
    </span>
  }
</div>
